import { Moment } from 'moment';

export class ProviderDeal {
	providerDealId: number;
	name: string;
	description: string;

	addedBy: string;
	updatedBy: string;

	createdOn: Moment | string;
	updatedOn: Moment | string;
}

export interface UpdatedProviderDeal {
	name: string;
	description: string;
}

export interface NewProviderDeal extends UpdatedProviderDeal {
	providerId: number;
	productId?: number;
}
